import {
  Component,
  computed,
  effect,
  HostListener,
  input,
  output,
  Pipe,
  PipeTransform,
  signal,
} from "@angular/core";
import { BildData } from "../berichte.component";
import { SafeUrl } from "@angular/platform-browser";
import { FormControl, FormGroup } from "@angular/forms";

@Component({
  selector: "bericht-image-gallery",
  templateUrl: "./img-gallery.component.html",
  styleUrl: "./img-gallery.component.scss",
  standalone: false,
})
export class BerichtImageGalleryComponent {
  public images = input<BildData[]>([]);
  public delete = output<string>();

  activeIndex = signal<number | null>(null);
  activeImage = computed(() =>
    this.activeIndex() === null
      ? null
      : this.images()[this.activeIndex() as number],
  );

  public controls = new FormGroup({});

  constructor() {
    effect(() => {
      this._updateControls();
    });

    this.controls.valueChanges.subscribe(() => this._updateImageData());
  }

  private _updateControls() {
    const imageIds = new Set(this.images().map((i) => i["ImageID"]));

    Object.keys(this.controls.controls).forEach((id) => {
      if (!imageIds.has(id)) {
        this.controls.removeControl(id);
      }
    });

    this.images().forEach((img) => {
      if (!this.controls.get(img["ImageID"])) {
        this.controls.addControl(
          img["ImageID"],
          new FormGroup({
            label: new FormControl(img["Label"]),
            desc: new FormControl(img["Beschreibung"]),
          }),
          { emitEvent: false },
        );
      }
    });
  }

  private _updateImageData() {
    this.images().forEach((img) => {
      const group = this.controls.get(img.ImageID) as FormGroup | null;
      if (!group) return;
      img.Label = group.get("label")?.value ?? "";
      img.Beschreibung = group.get("desc")?.value ?? "";
    });
  }

  public srcOf(img: BildData): SafeUrl | string | null {
    return img.srcOverride ?? img.imgSrc;
  }

  public onDelete(id: string) {
    this.delete.emit(id);
  }

  public open(i: number): void {
    this.activeIndex.set(i);
  }

  public close(): void {
    this.activeIndex.set(null);
  }

  public next(): void {
    if (this.activeIndex() === null) return;
    this.activeIndex.set(
      ((this.activeIndex() as number) + 1) % this.images().length,
    );
  }

  public prev(): void {
    if (this.activeIndex === null) return;
    const len = this.images().length;
    this.activeIndex.set(((this.activeIndex() as number) - 1 + len) % len);
  }

  public trackById(_: number, img: BildData): string {
    return img.ImageID;
  }

  @HostListener("window:keydown", ["$event"])
  onKey(e: KeyboardEvent): void {
    if (this.activeIndex === null) return;
    if (e.key === "Escape") this.close();
    else if (e.key === "ArrowRight") this.next();
    else if (e.key === "ArrowLeft") this.prev();
  }
}

@Pipe({ name: "berichCtlEval", standalone: false })
export class BerichtCtlEvalPipe implements PipeTransform {
  transform(form: FormGroup, id: string, name: string): FormControl | null {
    return form.get(id)?.get(name) as FormControl | null;
  }
}
